// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import loadTaxExemptionCertificates from "@store/Framework/Store/Greif/Data/TaxExemptionCertificates/Handlers/LoadTaxExemptionCertificates";
import {
    getTaxExemptionCertificatesDataView,
    TaxExemptionCertificatesDataViewContext,
} from "@store/Framework/Store/Greif/Data/TaxExemptionCertificates/TaxExemptionCertificatesSelectors";
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const { getTaxExemptionCertificatesParameter } = state.greif.pages.taxExemptionCertificates;

    return {
        getTaxExemptionCertificatesParameter,
        tecDataView: getTaxExemptionCertificatesDataView(state, getTaxExemptionCertificatesParameter),
    };
};

const mapDispatchToProps = {
    loadTaxExemptionCertificates,
};

type Props = PageProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

interface TaxExemptionCertificatePageStyles {
    page?: MobiusPageProps;
}

const taxExemptionCertificatePageStyles: TaxExemptionCertificatePageStyles = {};

const styles = taxExemptionCertificatePageStyles;

const TaxExemptionCertificatesPage = ({
    id,
    tecDataView,
    getTaxExemptionCertificatesParameter,
    loadTaxExemptionCertificates,
}: Props) => {
    useEffect(() => {
        if (!tecDataView.value && !tecDataView.isLoading) {
            loadTaxExemptionCertificates(getTaxExemptionCertificatesParameter);
        }
    });

    return (
        <Page data-test-selector="taxExemptionCertificates" {...styles.page}>
            <TaxExemptionCertificatesDataViewContext.Provider value={tecDataView}>
                <Zone contentId={id} zoneName="Content" />
            </TaxExemptionCertificatesDataViewContext.Provider>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(TaxExemptionCertificatesPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;
